import { convertMsToHMSText } from "@/utils/helper-functions.js";

import Spotify from "spotify-web-api-node";
var ServerMethods = require("spotify-web-api-node/src/server-methods");
Spotify._addMethods(ServerMethods);

let authEndpoint = "https://accounts.spotify.com/authorize";
var scopes = [
    "streaming",
    "playlist-read-private",
    "user-read-private",
    "user-modify-playback-state",
    "user-read-currently-playing",
    "user-read-recently-played",
    "user-read-playback-state",
    "user-top-read",
    "user-read-email",
    "user-read-playback-position", 
    "playlist-read-collaborative"
];


let redirectUri = "", authorizeURL = "";
let client_id = "", client_secret = ""
let spotifyApi;

export function getSpotifyToken(client_name, user_type = 'admin') {
    console.log(client_name, user_type)

    let client_name_to = 'doom_yoga'
    if (client_name == 'DY') {
        client_name_to = "doom_yoga"
    } else if (client_name == "MID") {
        client_name_to = "my_irish_date"
    }
    let testurl = ""
    if (window.location.pathname.includes("test_mid")) {
        testurl = "/test_mid"
    }

    if (client_name_to == "doom_yoga") {

        redirectUri =
            window.location.origin + testurl + "/" + client_name_to + "/music_library";

        if (user_type == 'customer') {
            redirectUri =
                window.location.origin + testurl + "/" + client_name_to + "/music";
        }

        client_id = process.env.DOOM_YOGA_CLIENT_ID
        client_secret = process.env.DOOM_YOGA_CLIENT_SECRET
    } else {
        redirectUri =
            window.location.origin +
            "/" +
            client_name_to +
            "/music_library/spotify_playlists";

        client_id = process.env.MID_SPOTIFY_CLIENT_ID
        client_secret = process.env.MID_SPOTIFY_CLIENT_SECRET
    }
    spotifyApi = new Spotify({
        redirectUri: redirectUri,
        clientId: client_id,
        clientSecret: client_secret,
    });
    authorizeURL = spotifyApi.createAuthorizeURL(scopes);

    getSpotifyAccessToken()

    console.log("***************", convertMsToHMSText(new Date()))
    console.log(process.env.DOOM_YOGA_CLIENT_ID)
    console.log(client_id)
    console.log(client_secret)
}

export function getSpotifyAccessToken() {
    console.log("in get spotify access token ");
    if (localStorage.getItem("spotify_access_token") != null) {
        console.log(
            Date.now() - localStorage.getItem("spotify_token_timestamp")
        );
        let diff = Date.now() - localStorage.getItem("spotify_token_timestamp");
        console.log(diff);
        if (diff > 3600 * 1000) {
            console.log("token expired");
            spotifyApi.setRefreshToken(
                localStorage.getItem("spotify_refresh_token")
            );
            spotifyApi.refreshAccessToken().then(
                function (data) {
                    console.log("The access token has been refreshed!");
                    console.log(data.body);

                    // Save the access token so that it's used in future calls
                    spotifyApi.setAccessToken(data.body["access_token"]);
                    localStorage.setItem(
                        "spotify_access_token",
                        data.body["access_token"]
                    );
                    // localStorage.setItem(
                    //   "spotify_refresh_token",
                    //   data.body["refresh_token"]
                    // );
                    localStorage.setItem("spotify_token_timestamp", Date.now());
                },
                function (err) {
                    console.log("Could not refresh access token", err);
                }
            );
        } else {
            spotifyApi.setAccessToken(
                localStorage.getItem("spotify_access_token")
            );
        }
    } else {
        var urlParams = new URLSearchParams(window.location.search);
        if (!urlParams.has("code")) {
            window.location = authorizeURL;
        } else {
            var code = urlParams.get("code");
            spotifyApi.authorizationCodeGrant(code).then(
                function (data) {
                    console.log("The token expires in " + data.body["expires_in"]);
                    // console.log("The access token is " + data.body["access_token"]);
                    // console.log("The refresh token is " + data.body["refresh_token"]);

                    // console.log(this.spotifyApi)
                    // Set the access token on the API object to use it in later calls
                    spotifyApi.setAccessToken(data.body["access_token"]);
                    spotifyApi.setRefreshToken(data.body["refresh_token"]);

                    localStorage.setItem(
                        "spotify_access_token",
                        data.body["access_token"]
                    );
                    localStorage.setItem(
                        "spotify_refresh_token",
                        data.body["refresh_token"]
                    );
                    localStorage.setItem("spotify_token_timestamp", Date.now());
                },
                function (err) {
                    console.log("Something went wrong!", err);
                }
            );
        }
    }

}


// WEBPACK FOOTER //
// ./src/utils/spotify-functions.js